module.exports = "/_next/static/images/CompleteDataCollectedMobile@2x-0d748ee83354f9f05fe4a292625f8793.webp";